import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import SettingsIcon from '@mui/icons-material/Settings';
import NewEditor from './TextEditor/NewEditor';
import DistrictSettings from './Modals/DistrictSettings';
import PostCard from './PostCard';

const DistrictPage = ({ currentUser, districts, dispatchPosts, posts, banner, setBanner, socket }) => {

    const { id } = useParams();
    const [loading, setLoading] = useState(true);

    const [lastId, setLastId] = useState();

    const [showSettings, setShowSettings] = useState(false);

    const handleDistrictSettings = () => {
        setShowSettings(true);
    }

    useEffect(() => {
        if (id !== lastId) {
            setLoading(true);
            setLastId(id);
        }
        if (loading) {
            setBanner({ loading: false, id: id });
            setLoading(false);
            window.scrollTo(0, 0);
        }
    })

    return (
        districts.map(d => (
            d.district.toString() === id && (
                <Box key={d._id}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                        <Card sx={{ width: '100%' }}>
                            <CardContent sx={{ textAlign: 'center' }}>
                                <Typography variant="h5">{d.district} MHz</Typography>
                                {(currentUser.isAuthenticated && (currentUser.user.isAdmin > 8 || (currentUser.user.isAdmin.toString() === id && window.location.href.includes('district'))) && currentUser.adminSettings) && (
                                    <IconButton onClick={handleDistrictSettings} size="small">
                                        <SettingsIcon fontSize="small" />
                                    </IconButton>
                                )}
                                {d.modes[0] && (
                                    <Stack direction="row" spacing={0.5} justifyContent="center" flexWrap="wrap" useFlexGap sx={{ mt: 1 }}>
                                        {d.modes.map((m, i) => (
                                            <Chip key={i} label={m.value} size="small" />
                                        ))}
                                    </Stack>
                                )}
                                <Box sx={{ mt: 2 }}>
                                    <Chip
                                        label={d.status === "Off Air" ? "Off Air" : "On Air"}
                                        color={d.status === "Off Air" ? "error" : "success"}
                                        size="small"
                                    />
                                </Box>
                            </CardContent>
                        </Card>
                    </Box>
                    <Stack spacing={2}>
                        {(() => {
                            const districtPosts = [...posts]
                                .filter(p => p.type === `district${d.district}`)
                                .sort((a, b) => (a.order > b.order ? 1 : -1));
                            return districtPosts.map(p => (
                                <PostCard
                                    key={p._id}
                                    post={p}
                                    siblings={districtPosts}
                                    currentUser={currentUser}
                                    dispatchPosts={dispatchPosts}
                                    socket={socket}
                                />
                            ));
                        })()}
                    </Stack>
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                        {(currentUser.isAuthenticated && currentUser.user.isAdmin > 8 && currentUser.adminSettings ||
                            currentUser.isAuthenticated && currentUser.user.isAdmin === d.district && currentUser.adminSettings) && (
                                <Card sx={{ textAlign: 'center', cursor: 'pointer', width: '100%' }}>
                                    <NewEditor
                                        dispatchPosts={dispatchPosts}
                                        currentUser={currentUser}
                                        type={`district${d.district}`}
                                        socket={socket}
                                    />
                                </Card>
                            )}
                    </Box>
                    <DistrictSettings
                        district={d}
                        showSettings={showSettings}
                        setShowSettings={setShowSettings}
                        currentUser={currentUser}
                        socket={socket}
                    />
                </Box>
            )
        ))
    );
};

export default DistrictPage;
